import type { User } from "lucia";

/**
 * Refresh the user data from the server, update the user state and return the
 * user value.
 */
const refreshUserData = async (): Promise<User | null> => {
  const user = useUser();
  const { data, error } = await useFetch("/api/auth/me");
  if (error.value) throw createError("Failed to fetch data");
  user.value = data.value?.user ?? null;
  return user.value;
};

/**
 * NOTE: Nuxt RouteMiddleware is a FRONTEND middleware (executed before render).
 * This is executed on every page load / route change.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const user = await refreshUserData();

  // always enable access to the login page, regardless of the further rules
  if (to.path === Page.AUTH_LOGIN) {
    return;
  }

  // restrict access to all admin pages
  if (to.path.startsWith(Page.ADMIN)) {
    if (!isUserAdmin(user)) {
      return navigateTo(`${Page.AUTH_LOGIN}?reason=unauthorized`);
    }
    return;
  }

  // allow access to other pages
  return;
});
